/**
 * Checks if object is empty
 * @param checkObject Object to check if it is empty
 * @returns True or false depending if the object is empty
 */
export const isEmptyObject = <CheckObject extends Partial<Record<keyof CheckObject, unknown>>>(
	checkObject: CheckObject,
): boolean => Object.entries(checkObject).length === 0 && checkObject.constructor === Object;
